import { BaseRequest } from "./baseRequest";

export class ConfReportRequest extends BaseRequest {
  confSessionId?: number;
  configurationId?: number;
  reportId?: number;
}